export default __webpack_public_path__ + "static/media/person.97c50961.jpeg";